var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.html)?_c('div',{staticClass:"x-terms-of-service"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})]):_c('spinner',{staticClass:"m-y-5 m-x-auto"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }